import React from 'react'
import '../styles/messagePage.scss'
import NavBar from './Navigation'

function MessagePage() {
  return (
    <>
        <NavBar/>
        <div id="main">
            <div className="fof">
                <h1>Page not yet built</h1>
            </div>
        </div>
    </>
  )
}

export default MessagePage